import SavedSeedPhrasesBottomSheet from './SavedSeedPhrasesBottomSheet'

export default SavedSeedPhrasesBottomSheet
